// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import vueResource from 'vue-resource'
import vueLazyLoad from 'vue-lazyload'
import infiniteScroll from 'vue-infinite-scroll'
import Base64 from 'js-base64'
import { Button, InputNumber,Table } from 'element-ui';
import QRCode from 'qrcodejs2'
import vueQr from 'vue-qr'
import ElementUI from 'element-ui'
import "./assets/icon/iconfont.css"



Vue.use(ElementUI);
 Vue.component(Button.name, Button);
 Vue.component(InputNumber.name, InputNumber);
 Vue.component(Table.name, Table);
Vue.use(vueResource)
Vue.use(vueLazyLoad,{
	loading:"./static/loading-svg/loading-bars.svg"  // 设置图片懒加载
})
Vue.use(infiniteScroll)
Vue.use(Base64)
//Vue.use(QRCode)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js